import React from 'react';
import PropTypes from 'prop-types';
import { convertDateToDayMonthYear, convertTime } from '../../../../lib/formatDate';
import Button from '../../../shared/form/_Button';
import AcceptTradeRequestModal from '../AcceptTradeRequestModal';
import RejectTradeRequestModal from '../RejectTradeRequestModal';
import { tradeAcceptModal, tradeRejectModal } from '../../../../constants/modals';
import Immutable from 'immutable';

const TradeOffersReceivedDesktop = ({ tradeOffersReceived, onHandleShowTradeAcceptModal }) => {
  return (
    tradeOffersReceived.valueSeq().map((tradeOfferReceived) => (
      <React.Fragment key={ tradeOfferReceived.get('id') }>
        <div className='trade-post__row' >
          <div className='trade-post__cell trade-post__office'>
            {tradeOfferReceived.getIn(['requestedAppointment', 'office', 'name'])}
          </div>
          <div className='trade-post__cell trade-post__requester'>
            {tradeOfferReceived.getIn(['requester', 'name'])}
          </div>
          <div className='trade-post__cell trade-post__offered-appt'>
            {convertDateToDayMonthYear(tradeOfferReceived.getIn(['offeredAppointment', 'scheduledOn']))}{' '}
            {convertTime(tradeOfferReceived.getIn(['offeredAppointment', 'from']))}

          </div>
          <div className='trade-post__cell trade-post__requested-appt'>
            {convertDateToDayMonthYear(tradeOfferReceived.getIn(['requestedAppointment', 'scheduledOn']))}{' '}
            {convertTime(tradeOfferReceived.getIn(['requestedAppointment', 'from']))}
          </div>
          <div className='trade-post__cell trade-post__status'>
            <div className={ 'trade-post__buttons' }>
              <Button className='trade-post__accept-button' onClick={ onHandleShowTradeAcceptModal(tradeAcceptModal(tradeOfferReceived.get('id'))) }>Accept</Button>
              <Button className='trade-post__reject-button' onClick={ onHandleShowTradeAcceptModal(tradeRejectModal(tradeOfferReceived.get('id'))) }>Reject</Button>
            </div>
          </div>
        </div>
        <AcceptTradeRequestModal id={ tradeAcceptModal(tradeOfferReceived.get('id')) } tradeOfferId={ tradeOfferReceived.get('id') } />
        <RejectTradeRequestModal id={ tradeRejectModal(tradeOfferReceived.get('id')) } tradeOfferId={ tradeOfferReceived.get('id') } />
      </React.Fragment>
    ))
  );
};

TradeOffersReceivedDesktop.propTypes = {
  onHandleShowTradeAcceptModal: PropTypes.func.isRequired,
  tradeOffersReceived: PropTypes.instanceOf(Immutable.Map).isRequired

};

export default TradeOffersReceivedDesktop;



// WEBPACK FOOTER //
// ./app/components/reps/trade_post/pending/TradeOffersReceivedDesktop.jsx